import { NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import { CreateEnvironmentDialogComponent, DeleteEnvironmentDialogComponent, DemoVersionsDialogComponent } from './components/dashboard/dashboard.component';
import { SignOutDialogComponent } from './components/header/header.component'

import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { ErrorStateMatcher, ShowOnDirtyErrorStateMatcher } from '@angular/material/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideDatabase, getDatabase } from '@angular/fire/database';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { provideStorage, getStorage } from '@angular/fire/storage';
import { CarouselModule } from '@coreui/angular';


import { environment } from '../environments/environment';
import { DaysRemainingPipe } from './days-remaining.pipe';

import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule } from '@angular/material/expansion';
import { AuthActionComponent } from './components/auth-action/auth-action.component';
import { AuthMessageComponent } from './components/auth-message/auth-message.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { FooterComponent } from './components/footer/footer.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { HeaderComponent } from './components/header/header.component';
import { SignInComponent } from './components/sign-in/sign-in.component';
import { AutoFocus } from './components/sign-up/autofocus.directive';
import { LicenseDialogComponent, SignUpComponent } from './components/sign-up/sign-up.component';
import { SlidesComponent } from './components/slides/slides.component';
import { UtilizationWidgetComponent } from './components/utilization-widget/utilization-widget.component';
import { VerifyEmailComponent } from './components/verify-email/verify-email.component';

// routing
import { AppRoutingModule } from './app-routing.module';

// service
import { ResetPasswordComponent } from './components/auth-action/reset-password/reset-password.component';
import { AuthService } from './shared/services/auth.service';
import { ConfirmEmailVerificationComponent } from './components/auth-action/confirm-email-verification/confirm-email-verification.component';
import { IconHeaderDescriptionCardComponent } from './components/icon-header-description-card/icon-header-description-card.component';
import { ProfileCompletionComponent } from './components/profile-completion/profile-completion.component';

@NgModule({
  declarations: [
    AppComponent,
    DaysRemainingPipe,
    CreateEnvironmentDialogComponent,
    DeleteEnvironmentDialogComponent,
    DemoVersionsDialogComponent,
    SignOutDialogComponent,
    SignInComponent,
    SignUpComponent,
    AutoFocus,
    LicenseDialogComponent,
    AuthMessageComponent,
    ForgotPasswordComponent,
    UtilizationWidgetComponent,
    VerifyEmailComponent,
    AuthActionComponent,
    DashboardComponent,
    HeaderComponent,
    FooterComponent,
    SlidesComponent,
    ResetPasswordComponent,
    ConfirmEmailVerificationComponent,
    IconHeaderDescriptionCardComponent,
    ProfileCompletionComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatSliderModule,
    MatTableModule,
    MatTabsModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    FontAwesomeModule,
    HttpClientModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatIconModule,
    MatDialogModule,
    MatSnackBarModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatChipsModule,
    MatExpansionModule,
    MatMenuModule,
    MatTooltipModule,
    MatBadgeModule,
    CarouselModule,
  ],
  providers: [
    Title,
    {provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: {duration: 20000}},
    {provide: ErrorStateMatcher, useClass: ShowOnDirtyErrorStateMatcher },
    {provide: 'googleTagManagerId',  useValue: 'GTM-5XXHJRH'},
    AuthService,
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),
    provideStorage(() => getStorage()),
    provideDatabase(() => getDatabase()),
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
